var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-col',{staticClass:"pt-0 pb-0",attrs:{"cols":"2"}},[_c('v-text-field',{attrs:{"value":_vm.formattedPrice,"label":_vm.$t('advert.price')},on:{"change":function($event){return _vm.handlePriceInput($event)}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }